exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".thumbnail-container {\r\n    float: left;\r\n    margin: 10px;\r\n}\r\n\r\n.thumbnail-image {\r\n    border: 1px solid #ccc;\r\n    height: 160px;\r\n    width: 120px;\r\n}\r\n\r\n.thumbnail-image img {\r\n    width: 100%;\r\n}\r\n\r\n.thumbnail-title {\r\n    font-size: 0.8em;\r\n    text-align: center;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/campaign/campaign-manage/campaign-manage.component.css
// module id = 877
// module chunks = 8